// validation enforces passport number to be at least 7 chars long
export const maskPassportNumber = (passportNumber: string) =>
  passportNumber.slice(0, 3) + "*".repeat(passportNumber.length - 3);
